export const status = {
    PLAYER_INFO_GENDER: 'PLAYER_INFO_GENDER', 
    PLAYER_INFO_AGE: 'PLAYER_INFO_AGE', 
    PLAYER_STYLES: 'PLAYER_STYLES', 
    INSTRUCTION_FACE_READER: 'INSTRUCTION_FACE_READER', 
    FACE_READER: 'FACE_READER', 
    FACE_CALC: 'FACE_CALC', 
    FACE_GLASS: 'FACE_GLASS', 
}